import React from "react";
import classnames from "classnames";
import "./TitleGroup.scss";
import { Separator } from "./CustomBootstrap";
import { Link } from "react-router-dom";

function TitleGroup(props) {
  const { children } = props;
  return <div className="title-has-btn clearfix">{children}</div>;
}

export function Title(props) {
  const { title, className } = props;
  return (
    <h2
      // className={`box-title text-uppercase font-weight-bold ${className && className}`}
      className={classnames({
        "box-title text-uppercase font-weight-bold": true,
        [className]: className
      })}
    >
      {title}
    </h2>
  );
}

export function PageTitle(props) {
  const { title, subtitle, separator } = props;
  return (
    <div className="page-title font-weight-bold">
      <h2>{title}</h2>
      <span>{subtitle}</span>
      {separator && <Separator />}
    </div>
  );
}

export function SeeAllButton(props) {
  const { link } = props;
  return (
    <Link to={link ? link : "#!"} className="see-all-btn">
      <span className="d-none d-md-block">See All</span>
      <span className="d-md-none">
        <img src="/img/icons/see-all-arrow.svg" alt="" />
      </span>
    </Link>
  );
}

export default TitleGroup;
